const MOBILE_BREAKPOINT = 480;

/**
 * tel:リンクのレスポンシブ制御
 * 480px以下: 下線表示・クリック有効
 * PC時: 下線なし・クリック無効
 */
export const telLinks = {
  init: () => {
    const updateTelLinksUnderline = () => {
      const links = document.querySelectorAll<HTMLAnchorElement>(
        'a[href^="tel:"]'
      );
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      links.forEach((link) => {
        link.style.textDecoration = isMobile ? 'underline' : '';
        link.style.pointerEvents = isMobile ? 'auto' : 'none';
      });
    };

    window.addEventListener('resize', updateTelLinksUnderline);
    window.addEventListener('load', updateTelLinksUnderline);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateTelLinksUnderline);
    } else {
      updateTelLinksUnderline();
    }
  },
};